<template>
    <div>
        <v-dialog v-model="dialogPreview" v-if="dataFromStore" persistent no-click-animation fullscreen hide-overlay
            scrollable transition="dialog-bottom-transition">
            <v-card height="100%" width="100%" rounded="0">
                <v-card-text class="fill-height pa-0 ma-0" style="background-color: #F8F8F8;">
                    <v-row class="d-flex pt-3 pr-3">
                        <v-col cols="12" class="d-flex justify-end">
                            <v-btn color="primary" @click="downloadPDF">
                                Download PDF
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-container fluid style="margin-top: -1.5vw;">
                        <div v-for="(page, index) in dataFromStore" :key="index" ref="pdfContent">
                            <component :is="'page-' + page.type" v-bind:page="page" v-bind:isPreview="true"
                                v-bind:bgColor="page.backgroundColor" v-bind:headerTitle="page.heading"
                                v-bind:bodyCopy="page.bodyCopy" v-bind:buttonText="page.buttonText"
                                v-bind:type="page.type" v-bind:name="page.name" v-bind:imageName="page.imageName"
                                v-bind:question="page.question" v-bind:imageNameQuestion="page.imageNameQuestion"
                                v-bind:answer1="page.answer1" v-bind:answer2="page.answer2"
                                v-bind:answer3="page.answer3" v-bind:answer4="page.answer4"
                                v-bind:imageNameAnswer1="page.imageNameAnswer1"
                                v-bind:imageNameAnswer2="page.imageNameAnswer2"
                                v-bind:imageNameAnswer3="page.imageNameAnswer3"
                                v-bind:imageNameAnswer4="page.imageNameAnswer4"
                                v-bind:correctAnswer="page.correctAnswer" :is-correct="isCorrect"
                                :is-selected="isSelected" />
                        </div>
                    </v-container>
                </v-card-text>
            </v-card>
            <div v-if="loading" class="overlay">
                <div class="spinner"></div>
                <div class="loading-text">Creating a PDF...</div>
            </div>
        </v-dialog>
        <div v-else>
            <p>No data</p>
        </div>
    </div>
</template>
<style scoped>
.overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 99999;
    pointer-events: all;
}

.loading-text {
    margin-top: 15px;
    color: #fff;
    font-size: 16px;
    font-weight: bold;
}

.spinner {
    border: 8px solid #f3f3f3;
    border-top: 8px solid #3498db;
    border-radius: 50%;
    width: 60px;
    height: 60px;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}
</style>
<script>
/* eslint-disable no-console */
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

import newTraining1 from "../trainingModulePageNew1.vue";
import newTraining2 from "../trainingModulePageNew2.vue";
import newTraining3 from "../trainingModulePageNew3.vue";
import newTraining4 from "../trainingModulePageNew4.vue";
import newTraining5 from "../trainingModulePageNew5.vue";
import newTraining6 from "../trainingModulePageNew6.vue";
import newTraining7 from "../trainingModulePageNew7.vue";

import newTraining8 from "../trainingModulePageNew8.vue";
import newTraining9 from "../trainingModulePageNew9.vue";
import newTraining10 from "../trainingModulePageNew10.vue";
import newTraining11 from "../trainingModulePageNew11.vue";
import newTraining12 from "../trainingModulePageNew12.vue";
import newTraining13 from "../trainingModulePageNew13.vue";
import newTraining14 from "../trainingModulePageNew14.vue";

import newquiz1 from "../quizModulePageNew1.vue";
import newquiz2 from "../quizModulePageNew2.vue";

export default {
    components: {
        "page-new-training-1": newTraining1,
        "page-new-training-2": newTraining2,
        "page-new-training-3": newTraining3,
        "page-new-training-4": newTraining4,
        "page-new-training-5": newTraining5,
        "page-new-training-6": newTraining6,
        "page-new-training-7": newTraining7,

        "page-new-training-8": newTraining8,
        "page-new-training-9": newTraining9,
        "page-new-training-10": newTraining10,
        "page-new-training-11": newTraining11,
        "page-new-training-12": newTraining12,
        "page-new-training-13": newTraining13,
        "page-new-training-14": newTraining14,

        "page-new-quiz-1": newquiz1,
        "page-new-quiz-2": newquiz2,
    },
    data: function () {
        return {
            loading: false,
            isCorrect: false,
            isSelected: false,
            dialogPreview: true,
        }
    },
    computed: {
        dataFromStore() {
            return this.$store.getters.getPreviewTrainingData
        }
    },
    methods: {
        async downloadPDF() {
            try {
                this.loading = true;
                const pageEls = this.$refs.pdfContent;

                const pdf = new jsPDF("l", "mm", "a4"); // landscape
                for (let i = 0; i < pageEls.length; i++) {
                    const el = pageEls[i];

                    const canvas = await html2canvas(el,
                        { scale: 2, useCORS: true });
                    const imgData = canvas.toDataURL("image/png");

                    const pageWidth = pdf.internal.pageSize.getWidth();
                    const pageHeight = pdf.internal.pageSize.getHeight();
                    const ratio = Math.min(pageWidth / canvas.width, pageHeight / canvas.height);
                    const finalWidth = canvas.width * ratio;
                    const finalHeight = canvas.height * ratio;

                    if (i > 0) pdf.addPage("a4", "l"); // landscape

                    pdf.addImage(
                        imgData,
                        "PNG",
                        (pageWidth - finalWidth) / 2,
                        (pageHeight - finalHeight) / 2,
                        finalWidth,
                        finalHeight
                    );
                }
                pdf.save("all-pages.pdf");
            } catch (e) {
                console.log("Error when creating PDF : ", e);
            } finally {
                this.loading = false;
            }
        },
    }
}
</script>
<style></style>
